import { render, staticRenderFns } from "./footerEgazar.vue?vue&type=template&id=ff718b66"
import script from "./footerEgazar.vue?vue&type=script&lang=js"
export * from "./footerEgazar.vue?vue&type=script&lang=js"
import style0 from "./footerEgazar.vue?vue&type=style&index=0&id=ff718b66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports